import axios, { AxiosHeaders } from 'axios';

const SESSION_TOKEN_KEY = 'gcm.sessionToken';

export const apiBaseUrl = process.env.REACT_APP_API_URL ?? '';

export const getStoredSessionToken = (): string | null => {
  return window.localStorage.getItem(SESSION_TOKEN_KEY);
};

export const setStoredSessionToken = (token: string): void => {
  window.localStorage.setItem(SESSION_TOKEN_KEY, token);
};

export const clearStoredSessionToken = (): void => {
  window.localStorage.removeItem(SESSION_TOKEN_KEY);
};

axios.interceptors.request.use((config) => {
  const headers = AxiosHeaders.from(config.headers);
  const sessionToken = getStoredSessionToken();
  const authorization = headers.get('Authorization');
  let trustedApiDestination = false;
  try {
    const expected = new URL(apiBaseUrl, window.location.href);
    const destination = new URL(axios.getUri(config), window.location.href);
    trustedApiDestination = Boolean(apiBaseUrl)
      && ['http:', 'https:'].includes(expected.protocol)
      && destination.origin === expected.origin
      && !destination.username && !destination.password;
  } catch {
    // Unknown/malformed destinations never receive a Gemstone session credential.
  }

  if (trustedApiDestination && sessionToken) {
    headers.set('X-GCM-Token', sessionToken);
  } else {
    headers.delete('X-GCM-Token');
  }

  if (typeof authorization === 'string' && authorization.startsWith('Basic ')) {
    headers.delete('Authorization');
  }

  config.headers = headers;

  return config;
});

export default axios;
